import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { ReimbursementList } from "../Responses"

export function useReimbursementsList() {
  return useQuery<ReimbursementList>({
    queryKey: ["Reimbursement/List"],
    queryFn: async () => {
      const response = await fetcher(
        "/Reimbursement/List",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()
      // return {
      //   providers: [],
      //   potentialClaims: 0,
      //   claims: [],
      // }

      return responseJson
    },
  })
}
